import { useEffect, useState } from 'react';
import { subscribeLiveExtensionOrigins } from '../extension/redir-state';

/**
 * Forces a re-render once Firefox's live extension-origin discovery
 * resolves (see redir-state.js), so a component that already called
 * getNext() on first render - before discovery finished - re-evaluates
 * it and can flip a previously-null "Return to extension" link on.
 * @returns {number} an opaque, incrementing version - value itself is unused
 */
export const useExtensionOriginsVersion = () => {
  const [version, setVersion] = useState(0);
  useEffect(
    () => subscribeLiveExtensionOrigins(() => setVersion((v) => v + 1)),
    [],
  );
  return version;
};
